import React from 'react'

export default (
	<svg width='47' height='47' viewBox='0 0 42 42'>
		<defs>
			<linearGradient
				id='html-a'
				x1='2.574%'
				x2='96.859%'
				y1='50%'
				y2='50%'
			>
				<stop offset='0%' stopColor='#FF7D50' />
				<stop offset='100%' stopColor='#FD5D21' />
			</linearGradient>
			<linearGradient
				id='html-b'
				x1='2.574%'
				x2='96.859%'
				y1='50%'
				y2='50%'
			>
				<stop offset='0%' stopColor='#FD5D21' />
				<stop offset='100%' stopColor='#FF7D50' />
			</linearGradient>
		</defs>
		<g fill='none' fillRule='evenodd' transform='translate(0 1)'>
			{/* <circle
				cx='21'
				cy='20'
				r='21'
				fill='url(#html-a)'
				fillOpacity='.35'
			/> */}
			<circle cx='21' cy='20' r='16' fill='url(#html-b)' />
			<path
				fill='#FFF'
				fillRule='nonzero'
				d='M13.0017152,11.7175409 L14.195752,27.2320361 C14.2206278,27.4594473 14.3698824,27.6615905 14.5937643,27.7373942 L20.8873333,29.7588268 C20.9868364,29.7840948 21.1112152,29.7840948 21.2355941,29.7588268 L27.529163,27.7373942 C27.7530449,27.6615905 27.9022995,27.4594473 27.9271753,27.2320361 L29.1212121,11.7175409 C29.0963364,11.3890581 28.8475787,11.1111111 28.5241937,11.1111111 L13.5489821,11.1111111 C13.2255971,11.1111111 12.9768395,11.3890581 13.0017152,11.7175409 Z M26.4031844,16.5016978 L18.6866975,16.5016978 L18.9085773,18.7005373 L26.2306112,18.7005373 L25.7621983,24.9684934 L21.4725218,26.3838384 L17.1828454,24.9937675 L16.9363123,21.7081453 L19.1797637,21.7081453 L19.1797637,23.3256824 L21.5218285,23.9828068 L23.8638932,23.3256824 L24.0364664,20.7730067 L16.8623523,20.7730067 L16.3939394,14.5050505 L26.5757576,14.5050505 L26.4031844,16.5016978 Z'
			/>
		</g>
	</svg>
)
